// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"building"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 6H19V10H20V21H4V10H5V6H8V3H16V6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 15V21H15V15H9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 15V21H15V15H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 6V3H8V6M16 6H19V10M16 6H8M8 6H5V10M19 10H5M19 10H20M5 10H4M4 10V21M4 10H3M4 21H3M4 21H20M20 10V21M20 10H21M20 21H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-building')
export default class BuildingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building',
    }
  }
}
